<template>
	<hr
		:class="classes"
		role="separator"
		:aria-orientation="vertical ? 'vertical' : 'horizontal'"
	>
</template>

<script>
export default {
	props: {
		inset: Boolean,
		vertical: Boolean
	},
	computed: {
		classes() {
			return {
				'ks-divider': true,
				'ks-divider--inset': this.inset,
				'ks-divider--vertical': this.vertical
			}
		}
	}
}
</script>

<style>
.ks-divider {
	display: block;
	flex: 1 1 0px;
	max-width: 100%;
	height: 0;
	max-height: 0;
	border: solid;
	border-width: thin 0 0 0;
	border-color: rgba(255, 255, 255, 0.12);
	transition: inherit;
}

.ks-divider--inset:not(.ks-divider--vertical) {
	margin-left: 72px;
	max-width: calc(100% - 72px);
}

.ks-divider--vertical {
	align-self: stretch;
	border: solid;
	border-width: 0 thin 0 0;
	display: inline-flex;
	height: inherit;
	min-height: 100%;
	max-height: 100%;
	max-width: 0;
	width: 0;
	vertical-align: text-bottom;
}

.ks-divider--vertical.ks-divider--inset {
	margin-top: 8px;
	min-height: 0;
	max-height: calc(100% - 16px);
}
</style>
